import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PROFILE_PASSWORD_FORM } from '../profile-password.constants';
import { BehaviorSubject, Subject, map, startWith, takeUntil } from 'rxjs';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ValidationPanelModule } from 'src/app/shared/components/validation-panel/validation-panel.module';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-profile-password-requirements',
  standalone: true,
  imports: [CommonModule, MaterialModule, ValidationPanelModule],
  templateUrl: './profile-password-requirements.component.html',
  styleUrls: ['./profile-password-requirements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfilePasswordRequirementsComponent implements OnInit, OnDestroy {
  @Input({ required: true })
  form!: typeof PROFILE_PASSWORD_FORM;

  protected readonly destroy$ = new Subject<void>();
  protected readonly contexts$ = new BehaviorSubject<TemplateContext[] | null>(null);
  protected readonly vm = Object.freeze({
    contexts: toSignal(this.contexts$, { requireSync: true }),
  });

  get password() {
    return this.form.controls.password;
  }

  get confirmation() {
    return this.form.controls.confirmation;
  }

  ngOnInit(): void {
    this.watchFormChanges();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected watchFormChanges() {
    this.form.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        startWith(this.form.getRawValue()),
        map((): TemplateContext[] => [
          {
            error: this.password.hasError('required'),
            text: 'Introducir contraseña',
          },
          {
            error:
              this.form.hasError('confirmation') ||
              this.password.hasError('required') ||
              this.confirmation.hasError('required'),
            text: 'La repetición debe coincidir',
          },
        ])
      )
      .subscribe((contexts) => this.contexts$.next(contexts));
  }
}

interface TemplateContext {
  error: boolean;
  text: string;
}
